import React, { useState, useEffect, useRef, memo } from "react"

const Dropdown = memo(
  ({ width, label, iconSrc, options, onSelect, selectedCategory }) => {
    const [isOpen, setIsOpen] = useState(false)
    const dropdownRef = useRef(null)
    const initialSelectionMade = useRef(false)

    useEffect(() => {
      if (
        options.length > 0 &&
        !selectedCategory &&
        onSelect &&
        !initialSelectionMade.current
      ) {
        initialSelectionMade.current = true
        onSelect(options[0].value)
      }
    }, [options, selectedCategory, onSelect])

    useEffect(() => {
      if (options.length > 0 && !selectedCategory) {
        initialSelectionMade.current = false
      }
    }, [options])

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (
          dropdownRef.current &&
          !dropdownRef.current.contains(event.target)
        ) {
          setIsOpen(false)
        }
      }

      document.addEventListener("mousedown", handleClickOutside)
      return () => {
        document.removeEventListener("mousedown", handleClickOutside)
      }
    }, [])

    const handleSelect = (option) => {
      setIsOpen(false)
      if (onSelect) {
        onSelect(option.value)
      }
    }

    // Match selected value to an option label (case-insensitive for string codes, e.g. country)
    const selectedLabel =
      options.find(
        (opt) =>
          String(opt.value).toUpperCase() ===
          String(selectedCategory ?? "").toUpperCase()
      )?.label || label

    const lang = localStorage.getItem("language") || "ar"

    return (
      <div
        ref={dropdownRef}
        className={`relative select-dropdown ${
          lang === "ar" ? "ml-10" : "mr-10"
        }`}
        onClick={() => setIsOpen(!isOpen)}
        style={{ width: width }}
      >
        <p
          className="mb-0 text-14 font-400 text-A1A1A1"
          style={
            width
              ? {
                  flex: 1,
                  minWidth: 0,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }
              : undefined
          }
        >
          {selectedLabel}
        </p>
        <div className="d-flex">
          <img src={iconSrc} alt="dropdown-icon" />
        </div>

        {isOpen && (
          <div className="absolute comon-dropdown " style={{ left: "0" }}>
            {options.map((option, index) => (
              <div
                className="dropdown-option"
                key={`${option.value}-${index}`}
                onClick={() => handleSelect(option)}
              >
                {option.label}
              </div>
            ))}
          </div>
        )}
      </div>
    )
  }
)

export default Dropdown
